<div class="viewSupplierWrapp">
  <div class="rfqHeader">
    <h3>Upload NDA</h3>
    <span class="termStatus" [ngClass]="customerInfo?.statusItem">
      {{ getNDALabel(customerInfo?.statusItem) }}
    </span>
    <div class="rfqActions">
      <span class="rfqClose" (click)="closeNda()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>

  <!-- docusign wait message -->
  <div class="messageContainer">
    <!-- <div  *ngIf="isDocusignFlowStarted" class="ndaLoadingContainer">
        <img src="/assets/images/gear-spinner.svg">
        <p class="message" *ngIf="isDocusignFlowStarted" >Please wait, you will be redirected soon.</p>
      </div> -->
    <!-- <p *ngIf="ndaData[0]?.ndaStatus === ndaStatus.PENDING && !isDocusignFlowStarted" class="message">The NDA is pending. Kindly sign the NDA to proceed.</p> -->
    <p
      *ngIf="
        ndaData[0]?.ndaStatus === ndaStatus.PENDING && !isDocusignFlowStarted
      "
      class="message"
    >
      Please download the NDA template and upload the duly signed.
    </p>
  </div>

  <!-- Download template -->
  <div class="rfqBody downloadTemplate">
    <div class="ndaWrapp">
      <div class="ndaReturned">
        <div class="ndaItem">
          <div class="liveItem">
            <h4 class="title grayFont">Download NDA Template</h4>
            <div
              class="ndaTitle"
              [ngClass]="{ borderGray: customerInfo?.statusItem }"
            >
              <div class="caption">
                <lucide-icon
                  name="file-text"
                  class="my-icon fileIco"
                  [size]="16"
                  color="#666666"
                ></lucide-icon>
                <h4>NON-DISCLOSURE AGREEMENT</h4>
              </div>
              <div class="downloadIco" (click)="downloadNdaTemplate()">
                <lucide-icon
                  name="download"
                  class="my-icon"
                  [size]="20"
                ></lucide-icon>
              </div>
              <!-- <div class="downloadIco" (click)="downloadNda(ndaItem)">
                <lucide-icon name="download" class="my-icon" [size]="20"></lucide-icon>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Upload nda -->

  <div class="pageview">
        <div class="rfqBody"   *ngIf="ndaData?.length !== 0 && ndaData[0].ndaStatus === 'PENDING'" >
          <div class="ndaWrapp">
            <div class="offline-nda" style="font-weight: 600">Upload NDA <sup>*</sup></div>
            <div class="fileUploader">
              <app-upload-dnd
             
                (fileUploadEvent)="fileUploadEvent($event)"
                [documentInfo]="documentInfo"
                [fileUploadConfig]="fileUploadConfig"
                [resetFileUpload]="resetFileUpload"
              ></app-upload-dnd>
            </div>
          </div>
        </div>
        <!-- <div class="bottom-button">
          <button class="btnCustom btn-outline but-supplier" (click)="closeNda()">Cancel</button>
          <button class="btnCustom btn-primary" (click)="acceptNda('OFF_LINE')" [disabled]="isDisabledAccept()">Submit</button>
        </div> -->
  </div>

  <div class="rfqBody">
    <div class="ndaWrapp">
      <!-- <div class="downloadTemplate" *ngIf="!ndaData?.length">
        <p>Use the UniBuild NDA Template and upload NDA Document</p>
        <button class="btn-dwntemp" (click)="downloadNdaTemplate()">
          <div class="downloadTemp"><lucide-icon name="download" class="my-icon" [size]="18" [strokeWidth]="1.5"></lucide-icon></div>
          Download NDA Template
        </button>
      </div> -->
      <div class="ndaWrapp">
        <div class="ndaReturned">
          <div class="ndaItem" *ngFor="let ndaItem of ndaData; let i = index">
            <div
              class="archiveItem"
              *ngIf="
                ndaItem?.fileStatus === fileStatus.Archive &&
                ndaItem?.envelopeId !== null
              "
            >
              <div class="receivedLabel">
                <div class="iconLb">
                  <lucide-icon
                    name="check"
                    class="my-icon"
                    [size]="12"
                    color="#fff"
                  ></lucide-icon>
                </div>
                NDA Sent
                <div
                  class="icon"
                  [hidden]="!isCollapsed[i]"
                  (click)="toggleCollapse(i)"
                >
                  <lucide-icon
                    name="SquareMinus"
                    class="my-icon"
                    [size]="16"
                    color="#666666"
                  ></lucide-icon>
                </div>
                <div class="icon" [hidden]="isCollapsed[i]">
                  <lucide-icon
                    name="SquarePlus"
                    (click)="toggleCollapse(i)"
                    class="my-icon"
                    [size]="16"
                    color="#666666"
                  ></lucide-icon>
                </div>
              </div>
              <div class="toggleItem" [hidden]="!isCollapsed[i]">
                <div class="ndaTitle">
                  <div class="caption">
                    <lucide-icon
                      name="file-text"
                      class="my-icon fileIco"
                      [size]="16"
                      color="#666666"
                    ></lucide-icon>
                    <h4>Non Disclosure Agreement</h4>
                    <span>{{
                      ndaItem?.createdOn | date : "MMM d, y, HH:mm:ss"
                    }}</span>
                  </div>
                  <div class="downloadIco" (click)="downloadNda(ndaItem)">
                    <lucide-icon
                      name="download"
                      class="my-icon"
                      [size]="20"
                    ></lucide-icon>
                  </div>
                </div>
              </div>
              <div class="returnLabel">
                <div class="iconLb">
                  <lucide-icon
                    name="redo-2"
                    class="my-icon"
                    [size]="12"
                    color="#6d1014"
                  ></lucide-icon>
                </div>
                NDA Returned
                <!-- <span class="viewDetails font-12" (click)="toggleCollapse(i)">Details</span> -->
                <div
                  class="icon"
                  [hidden]="!isCollapsedRtrn[i]"
                  (click)="toggleCollapseRtrn(i)"
                >
                  <lucide-icon
                    name="SquareMinus"
                    class="my-icon"
                    [size]="16"
                    color="#666666"
                  ></lucide-icon>
                </div>
                <div class="icon" [hidden]="isCollapsedRtrn[i]">
                  <lucide-icon
                    name="SquarePlus"
                    (click)="toggleCollapseRtrn(i)"
                    class="my-icon"
                    [size]="16"
                    color="#666666"
                  ></lucide-icon>
                </div>
              </div>
              <div class="toggleItem" [hidden]="!isCollapsedRtrn[i]">
                <div class="ndaTitle">
                  <div class="caption">
                    <lucide-icon
                      name="file-text"
                      class="my-icon fileIco"
                      [size]="16"
                      color="#666666"
                    ></lucide-icon>
                    <h4>Non Disclosure Agreement</h4>
                    <span>{{
                      ndaItem?.createdOn | date : "MMM d, y, HH:mm:ss"
                    }}</span>
                  </div>
                  <div class="downloadIco" (click)="downloadNda(ndaItem)">
                    <lucide-icon
                      name="download"
                      class="my-icon"
                      [size]="20"
                    ></lucide-icon>
                  </div>
                </div>
                <div class="ndaReason">
                  <p class="font-12 medium">
                    Reason for return
                    <span class="regular font-12 grayFont">{{
                      ndaItem?.createdOn | date : "MMM d, y, HH:mm:ss"
                    }}</span>
                  </p>
                  <p class="font-12">{{ ndaItem?.adminComment }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="ndaItem" *ngFor="let ndaItem of ndaData; let i = index">
            <div
              class="liveItem"
              *ngIf="
                ndaItem?.fileStatus === fileStatus.Live &&
                ndaItem?.ndaStatus !== ndaStatus.APPROVED
              "
            >
              <div class="receivedLabel">
                <div class="iconLb">
                  <lucide-icon
                    name="check"
                    class="my-icon"
                    [size]="12"
                    color="#fff"
                  ></lucide-icon>
                </div>
                NDA Sent
              </div>
              <div class="ndaTitle">
                <div class="caption">
                  <lucide-icon
                    name="file-text"
                    class="my-icon fileIco"
                    [size]="16"
                    color="#666666"
                  ></lucide-icon>
                  <h4>Non Disclosure Agreement</h4>
                  <span>{{
                    ndaItem?.createdOn | date : "MMM d, y, HH:mm:ss"
                  }}</span>
                </div>
                <div class="downloadIco" (click)="downloadNda(ndaItem)">
                  <lucide-icon
                    name="download"
                    class="my-icon"
                    [size]="20"
                  ></lucide-icon>
                </div>
              </div>
              <div
                class="returnLabel"
                *ngIf="customerInfo?.statusItem === ndaStatus.RETURNED"
              >
                <div class="iconLb">
                  <lucide-icon
                    name="redo-2"
                    class="my-icon"
                    [size]="12"
                    color="#DA2128"
                  ></lucide-icon>
                </div>
                NDA Returned
              </div>
              <div class="ndaReason" *ngIf="ndaItem?.adminComment">
                <p class="font-12 medium">
                  Reason for return
                  <span class="regular font-12 grayFont">{{
                    ndaItem?.createdOn | date : "MMM d, y, HH:mm:ss"
                  }}</span>
                </p>
                <p class="font-12">{{ ndaItem?.adminComment }}</p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="uploadSigned"
          *ngIf="customerInfo?.statusItem === ndaStatus.APPROVED"
        >
          <div class="uploadLabel checkedItem">
            <div class="iconLb">
              <lucide-icon
                name="check"
                class="my-icon"
                [size]="12"
                color="#fff"
              ></lucide-icon>
            </div>
            NDA Accepted
          </div>
          <div class="ndaItem" *ngFor="let ndaItem of ndaData">
            <div
              class="ndaTitle"
              *ngIf="
                ndaItem?.fileStatus === fileStatus.Live &&
                ndaItem?.ndaStatus === ndaStatus.APPROVED
              "
            >
              <div class="caption">
                <lucide-icon
                  name="file-text"
                  class="my-icon fileIco"
                  [size]="16"
                  color="#666666"
                ></lucide-icon>
                <h4>Non Disclosure Agreement</h4>
                <span>{{
                  ndaItem?.createdOn | date : "MMM d, y, HH:mm:ss"
                }}</span>
              </div>
              <div class="downloadIco" (click)="downloadNda(ndaItem)">
                <lucide-icon
                  name="download"
                  class="my-icon"
                  [size]="20"
                ></lucide-icon>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="uploadSigned" *ngIf="customerInfo?.statusItem === ndaStatus.PENDING || customerInfo?.statusItem === ndaStatus.RETURNED">
          <div class="uploadLabel" *ngIf="customerInfo?.statusItem === ndaStatus.RETURNED">
            <div class="iconLb">
              <lucide-icon name="check" class="my-icon" [size]="12" color="#fff"></lucide-icon>
            </div>
            Upload NDA
          </div>
          <div class="fileUploader" *ngIf="isStatausReview()">
            <app-upload-dnd
              (fileUploadEvent)="fileUploadEvent($event)"
              [documentInfo]="documentInfo"
              [fileUploadConfig]="fileUploadConfig"
              [resetFileUpload]="resetFileUpload"
            ></app-upload-dnd>
            <div class="downloadTemplate" *ngIf="ndaData?.length">
              <p>
                Need the NDA document? <span class="downldTemp" (click)="downloadNdaTemplate()"> Click here </span>to download Unibuild NDA
                document
              </p>
            </div>
          </div>
        </div> -->
        <div
          class="uploadSigned"
          *ngIf="
            !(
              customerInfo?.statusItem === ndaStatus.APPROVED ||
              customerInfo?.statusItem === ndaStatus.PENDING
            )
          "
        >
          <div class="uploadLabel">
            <div class="iconLb">
              <lucide-icon
                name="check"
                class="my-icon"
                [size]="12"
                color="#fff"
              ></lucide-icon>
            </div>
            Awaiting Approval
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="bottom-button"
    *ngIf="
      !(
        customerInfo?.statusItem === ndaStatus.APPROVED ||
        customerInfo?.statusItem === ndaStatus.IN_REVIEW
      )
    "
  >
    <button
      class="btnCustom btn-outline but-supplier"
      mat-button
      (click)="closeNda()"
    >
      Cancel
    </button>
    <button
      class="btnCustom btn-primary"
      mat-button
      (click)="saveNonNdaFile()"
      [disabled]="isDisabledAccept()"
    >
      Sign
    </button>
  </div>
</div>
